// src/components/admin/AdminContactsTopicDirectoryPanel.tsx

import { cardMutedTextClass, cardTitleTextClass, sectionCardClass } from "@/components/common/surfaceClasses";

export type TopicDirectoryUsageRow = { topic: string; count: number };

type Props = {
  topicDirectoryUsage: TopicDirectoryUsageRow[];
  onJumpToContactsSearch: (topic: string) => void;
};

/** Topic tags across the loaded directory with usage counts; jump to Contacts to filter/edit. */
export function AdminContactsTopicDirectoryPanel(props: Props) {
  const { topicDirectoryUsage, onJumpToContactsSearch } = props;

  return (
    <div className={sectionCardClass}>
      <div>
        <h3 className={`font-semibold ${cardTitleTextClass}`}>Topic tag coverage</h3>
        <p className={`text-xs mt-1 ${cardMutedTextClass}`}>
          Each number is how many active directory rows include that tag. Open the contacts list filtered by that tag to assign or edit in place.
        </p>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {topicDirectoryUsage.map(({ topic, count }) => (
          <button
            key={topic}
            type="button"
            title={`${count} contact(s) — open directory search`}
            onClick={() => onJumpToContactsSearch(topic)}
            className="inline-flex max-w-full items-center gap-1 truncate rounded-full border border-gray-200 bg-gray-50 px-2.5 py-1 text-left text-[11px] font-medium text-gray-800 hover:border-indigo-300 hover:bg-indigo-50 dark:border-zinc-700 dark:bg-zinc-800/60 dark:text-zinc-100 dark:hover:border-indigo-500 dark:hover:bg-indigo-950/50"
          >
            <span className="truncate">{topic}</span>
            <span className={`shrink-0 rounded-full px-1.5 py-0 text-[10px] tabular-nums border border-gray-200 bg-white dark:border-zinc-600 dark:bg-zinc-900/60 ${cardMutedTextClass}`}>
              {count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
